import { Grid } from "@material-ui/core";
import React from "react";

import ListUsers from "../lib/ListUsers";

import { BasePage } from "./BasePage";

export const UserManagementPage: BasePage = () => {
  return (
    <div>
      <Grid container spacing={3}>
        <ListUsers />
      </Grid>
    </div>
  );
};
